module.exports = [
	{
		"fund_id": "FSUSA00B4O",
		"investment_vehicle_id": "FEUSA0000E",
		"ticker": "IVV",
		"fund_legal_name": "iShares Core S&P 500 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 581544326554,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": 1,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.0887925894780105,
		"cl_weight": 0.24685458041135383,
		"fossil_bank_score": 14.2054,
		"fossil_insure_score": 25.5839,
		"wff_mil_weight": 0.03451542818598302,
		"mmc_weight": 0.03451542818598302,
		"cm_weight": 0.014700731910536877,
		"nw_weight": 0.02333135012653685,
		"wff_civ_weight": 0.00942842483717498,
		"gm_weight": 0.0014579948142354844,
		"gr_weight": 0.007970430022939495,
		"t_all_weight": 0.018338971616346005,
		"to_weight": 0.007294245705682557,
		"tm_weight": 0.01104472591066345,
		"po_producer_weight": 0.0018529772360236219,
		"po_financier_weight": 0.02594813414732472,
		"po_consumer_weight": 0.11805431318170621,
		"pp_weight": 0.18528693178296382,
		"borders_weight": 0.16767018053323504,
		"pp_high_weight": 0.0031174370108249627,
		"borders_high_weight": 0.017251581921296586,
		"pff_all_weight": 0.21774493778602624,
		"pff_all_high_weight": 0.017251581921296586,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 54.9584201494276,
		"gef_score_a": 26.735146931495958,
		"gef_score_b": 9.176300880301376,
		"gef_score_c": 18.39755518591031,
		"gef_score_d": 0.649417151713263,
		"gef_score_a_norm": 66.8378673287399,
		"gef_score_b_norm": 30.587669601004585,
		"gef_score_c_norm": 91.98777592955155,
		"gef_score_d_norm": 6.49417151713263,
		"prospectus_net_expense_ratio": 0.03,
		"trailing_return_m1": -5.63692,
		"trailing_return_m3": -4.27992,
		"trailing_return_m6": -1.98198,
		"trailing_return_y1": 8.21584,
		"trailing_return_y3": 9.03378,
		"trailing_return_y5": 18.55874,
		"trailing_return_y10": 12.46502,
		"trailing_return_y15": 13.10024,
		"trailing_return_y20": 10.18444,
		"performance_as_of_date": "2025-03-31T00:00:00.000Z",
		"index_name": "S&P 500",
		"footprint": 85.50252511049075,
		"intensity": 173.1109655083947,
		"name": "IVV - iShares Core S&P 500 ETF",
		"label": "IVV - iShares Core S&P 500 ETF"
	},
	{
		"fund_id": "FSUSA00B5E",
		"investment_vehicle_id": "FEUSA00014",
		"ticker": "IWV",
		"fund_legal_name": "iShares Russell 3000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 14431804509,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.08600943363638086,
		"cl_weight": 0.21787110732375253,
		"fossil_bank_score": 12.4726,
		"fossil_insure_score": 22.8634,
		"wff_mil_weight": 0.03616107561691638,
		"mmc_weight": 0.03616107561691638,
		"cm_weight": 0.014317309332377846,
		"nw_weight": 0.022825072123933844,
		"wff_civ_weight": 0.008691862021449085,
		"gm_weight": 0.0013728454677182068,
		"gr_weight": 0.007319016553730878,
		"t_all_weight": 0.016304730778299074,
		"to_weight": 0.006496379796355788,
		"tm_weight": 0.009808350981943291,
		"po_producer_weight": 0.0016282234854322422,
		"po_financier_weight": 0.022841317635871494,
		"po_consumer_weight": 0.10532083415023567,
		"pp_weight": 0.16504466921919722,
		"borders_weight": 0.150573766282646,
		"pp_high_weight": 0.003063129430780549,
		"borders_high_weight": 0.016388828324956486,
		"pff_all_weight": 0.1950561829747819,
		"pff_all_high_weight": 0.016400059415243844,
		"pff_all_extreme_weight": 0.00010974993078815113,
		"gef_score_norm": 53.57806464735585,
		"gef_score_a": 26.227404351345943,
		"gef_score_b": 8.66090265540411,
		"gef_score_c": 18.101582262720825,
		"gef_score_d": 0.5881753778788463,
		"gef_score_a_norm": 65.56851087836486,
		"gef_score_b_norm": 28.8696755180137,
		"gef_score_c_norm": 90.50791131360413,
		"gef_score_d_norm": 5.881753778788464,
		"prospectus_net_expense_ratio": 0.2,
		"trailing_return_m1": -5.84106,
		"trailing_return_m3": -4.76078,
		"trailing_return_m6": -2.30529,
		"trailing_return_y1": 7.01705,
		"trailing_return_y3": 8.04508,
		"trailing_return_y5": 17.98576,
		"trailing_return_y10": 11.62183,
		"trailing_return_y15": 12.57757,
		"trailing_return_y20": 9.9103,
		"performance_as_of_date": "2025-03-31T00:00:00.000Z",
		"index_name": "Russell 3000",
		"footprint": 97.39973655355976,
		"intensity": 177.28587948168712,
		"name": "IWV - iShares Russell 3000 ETF",
		"label": "IWV - iShares Russell 3000 ETF"
	},
	{
		"fund_id": "FSUSA00B5H",
		"investment_vehicle_id": "FEUSA00017",
		"ticker": "IWM",
		"fund_legal_name": "iShares Russell 2000 ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 63329250529,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 3,
		"c2f5coogutweight": 0.07625886629806089,
		"cl_weight": 0.0031210345156947907,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.02788649650882662,
		"mmc_weight": 0.02788649650882662,
		"cm_weight": 0.0027331723581939036,
		"nw_weight": 0.007238571701049011,
		"wff_civ_weight": 0.0020223604502557007,
		"gm_weight": 0.0007090355382493228,
		"gr_weight": 0.001313324912006378,
		"t_all_weight": 0.0020898721560411535,
		"to_weight": 0.0009856803824724756,
		"tm_weight": 0.001104191773568678,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.002546561328822806,
		"pp_weight": 0.0052090625885083,
		"borders_weight": 0.007968934231188664,
		"pp_high_weight": 0.003608368460318298,
		"borders_high_weight": 0.004738395091559815,
		"pff_all_weight": 0.009826218999373129,
		"pff_all_high_weight": 0.004994985731554277,
		"pff_all_extreme_weight": 0.0024648806359468057,
		"gef_score_norm": 38.362781614280124,
		"gef_score_a": 19.92359618212354,
		"gef_score_b": 3.391593116078529,
		"gef_score_c": 15.018372626792585,
		"gef_score_d": 0.029219689287211494,
		"gef_score_a_norm": 49.80899045530885,
		"gef_score_b_norm": 11.30531038692843,
		"gef_score_c_norm": 75.09186313396292,
		"gef_score_d_norm": 0.292196892872115,
		"prospectus_net_expense_ratio": 0.19,
		"trailing_return_m1": -6.80858,
		"trailing_return_m3": -9.48269,
		"trailing_return_m6": -9.21845,
		"trailing_return_y1": -4.13532,
		"trailing_return_y3": 0.41491,
		"trailing_return_y5": 13.14644,
		"trailing_return_y10": 6.24051,
		"trailing_return_y15": 8.94962,
		"trailing_return_y20": 7.52511,
		"performance_as_of_date": "2025-03-31T00:00:00.000Z",
		"index_name": "Russell 2000",
		"footprint": 175.68163166512545,
		"intensity": 149.69572190373236,
		"name": "IWM - iShares Russell 2000 ETF",
		"label": "IWM - iShares Russell 2000 ETF"
	},
	{
		"fund_id": "FSUSA00B5K",
		"investment_vehicle_id": "FEUSA0001A",
		"ticker": "IWB",
		"fund_legal_name": "iShares Russell 1000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 37163540495,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.0865022531554517,
		"cl_weight": 0.22789720135121025,
		"fossil_bank_score": 13.0459,
		"fossil_insure_score": 23.9241,
		"wff_mil_weight": 0.03649564987143724,
		"mmc_weight": 0.03649564987143724,
		"cm_weight": 0.014856732183135232,
		"nw_weight": 0.023516024674439945,
		"wff_civ_weight": 0.0090008045318327,
		"gm_weight": 0.0014066040780880203,
		"gr_weight": 0.0075942004537446805,
		"t_all_weight": 0.016960863368948746,
		"to_weight": 0.006748141636653679,
		"tm_weight": 0.010212721732295071,
		"po_producer_weight": 0.0017074958603949123,
		"po_financier_weight": 0.0238994408909997,
		"po_consumer_weight": 0.11010652343370407,
		"pp_weight": 0.17247992036234658,
		"borders_weight": 0.15717528465223332,
		"pp_high_weight": 0.0030329475569522827,
		"borders_high_weight": 0.01691865209028196,
		"pff_all_weight": 0.20364347444314948,
		"pff_all_high_weight": 0.01691865209028196,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 54.04980523236886,
		"gef_score_a": 26.422079203592983,
		"gef_score_b": 8.824989275802906,
		"gef_score_c": 18.197154582657863,
		"gef_score_d": 0.6055821703087413,
		"gef_score_a_norm": 66.05519800898246,
		"gef_score_b_norm": 29.416630919343024,
		"gef_score_c_norm": 90.98577291328931,
		"gef_score_d_norm": 6.055821703087413,
		"prospectus_net_expense_ratio": 0.15,
		"trailing_return_m1": -5.79849,
		"trailing_return_m3": -4.52553,
		"trailing_return_m6": -1.94076,
		"trailing_return_y1": 7.6589,
		"trailing_return_y3": 8.51288,
		"trailing_return_y5": 18.3042,
		"trailing_return_y10": 12.032,
		"trailing_return_y15": 12.87368,
		"trailing_return_y20": 10.11066,
		"performance_as_of_date": "2025-03-31T00:00:00.000Z",
		"index_name": "Russell 1000",
		"footprint": 93.63257600207086,
		"intensity": 180.5763346449502,
		"name": "IWB - iShares Russell 1000 ETF",
		"label": "IWB - iShares Russell 1000 ETF"
	},
	{
		"fund_id": "FSUSA00B7C",
		"investment_vehicle_id": "FEUSA0002W",
		"ticker": "EFA",
		"fund_legal_name": "iShares MSCI EAFE ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 56959895622,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 1,
		"c2f5coogutweight": 0.10958915798159939,
		"cl_weight": 0.12920030560849624,
		"fossil_bank_score": 30.7272,
		"fossil_insure_score": 24.131,
		"wff_mil_weight": 0.04409459876746142,
		"mmc_weight": 0.04409459876746142,
		"cm_weight": 0.02245863685003536,
		"nw_weight": 0.024952320260847757,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.017273791768073792,
		"to_weight": 0.008329108522631109,
		"tm_weight": 0.008944683245442685,
		"po_producer_weight": 0.013656571383808092,
		"po_financier_weight": 0.0829249495324472,
		"po_consumer_weight": 0.1095954251548754,
		"pp_weight": 0.015374981271055955,
		"borders_weight": 0.031124571362081944,
		"pp_high_weight": 0.0008660976578630133,
		"borders_high_weight": 0.006619604531579,
		"pff_all_weight": 0.03352692031880296,
		"pff_all_high_weight": 0.007485702189442014,
		"pff_all_extreme_weight": 0.00032284639997282976,
		"gef_score_norm": 57.623844563065106,
		"gef_score_a": 25.458528732396296,
		"gef_score_b": 13.370838721730129,
		"gef_score_c": 17.438219319203153,
		"gef_score_d": 1.3562577897297592,
		"gef_score_a_norm": 63.646321830990736,
		"gef_score_b_norm": 44.5694624057671,
		"gef_score_c_norm": 87.19109659601575,
		"gef_score_d_norm": 13.562577897297592,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": -0.16122,
		"trailing_return_m3": 7.9492,
		"trailing_return_m6": -1.16717,
		"trailing_return_y1": 5.55816,
		"trailing_return_y3": 6.62539,
		"trailing_return_y5": 11.95331,
		"trailing_return_y10": 5.44624,
		"trailing_return_y15": 5.64713,
		"trailing_return_y20": 5.14048,
		"performance_as_of_date": "2025-03-31T00:00:00.000Z",
		"index_name": "MSCI EAFE",
		"footprint": 166.34779529488438,
		"intensity": 200.12888979498774,
		"name": "EFA - iShares MSCI EAFE ETF",
		"label": "EFA - iShares MSCI EAFE ETF"
	},
	{
		"fund_id": "FSUSA04C4U",
		"investment_vehicle_id": "FEUSA04ABV",
		"ticker": "EEM",
		"fund_legal_name": "iShares MSCI Emerging Markets ETF",
		"morningstar_category_name": "Diversified Emerging Mkts",
		"fund_net_assets": 16515842314,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 3,
		"grade_gender_equality": -1,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 1,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.09993532471082206,
		"cl_weight": 0.12041281819049275,
		"fossil_bank_score": 8.3958,
		"fossil_insure_score": 6.7876,
		"wff_mil_weight": 0.0327889418009363,
		"mmc_weight": 0.0327889418009363,
		"cm_weight": 0.005653516017845559,
		"nw_weight": 0.020467303045325305,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.0031910964492988378,
		"to_weight": 0.0031910964492988378,
		"tm_weight": 0,
		"po_producer_weight": 0.0105902150492915,
		"po_financier_weight": 0.0216591990889525,
		"po_consumer_weight": 0.010412325885419724,
		"pp_weight": 0,
		"borders_weight": 0,
		"pp_high_weight": 0,
		"borders_high_weight": 0,
		"pff_all_weight": 0,
		"pff_all_high_weight": 0,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 46.90191285594023,
		"gef_score_a": 22.76920859342459,
		"gef_score_b": 7.371392723328258,
		"gef_score_c": 16.44911478452357,
		"gef_score_d": 0.31219675467438107,
		"gef_score_a_norm": 56.92302148356148,
		"gef_score_b_norm": 24.57130907776086,
		"gef_score_c_norm": 82.24557392261784,
		"gef_score_d_norm": 3.121967546743811,
		"prospectus_net_expense_ratio": 0.72,
		"trailing_return_m1": 1.26846,
		"trailing_return_m3": 3.87056,
		"trailing_return_m6": -3.30819,
		"trailing_return_y1": 8.68487,
		"trailing_return_y3": 1.3904,
		"trailing_return_y5": 7.34885,
		"trailing_return_y10": 3.12639,
		"trailing_return_y15": 2.39584,
		"trailing_return_y20": 5.40114,
		"performance_as_of_date": "2025-03-31T00:00:00.000Z",
		"index_name": "MSCI Emerging Markets",
		"footprint": 314.88973634654246,
		"intensity": 411.7265809951513,
		"name": "EEM - iShares MSCI Emerging Markets ETF",
		"label": "EEM - iShares MSCI Emerging Markets ETF"
	},
	{
		"fund_id": "FSUSA08N98",
		"investment_vehicle_id": "FOUSA06OEY",
		"ticker": "ACWX",
		"fund_legal_name": "iShares MSCI ACWI ex U.S. ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 5670411198,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.11771727180634396,
		"cl_weight": 0.12572450880560787,
		"fossil_bank_score": 29.7765,
		"fossil_insure_score": 17.4246,
		"wff_mil_weight": 0.03919923164082759,
		"mmc_weight": 0.03919923164082759,
		"cm_weight": 0.015891536278552883,
		"nw_weight": 0.02343557855040112,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.012015056938400324,
		"to_weight": 0.006213036367622491,
		"tm_weight": 0.0058020205707778345,
		"po_producer_weight": 0.011825812857694185,
		"po_financier_weight": 0.05941439831057087,
		"po_consumer_weight": 0.07461433200596286,
		"pp_weight": 0.011551530421531333,
		"borders_weight": 0.02096491636238144,
		"pp_high_weight": 0.0005548227754610861,
		"borders_high_weight": 0.005203709014178554,
		"pff_all_weight": 0.024173351222177383,
		"pff_all_high_weight": 0.00575853178963964,
		"pff_all_extreme_weight": 0.0002049829594829797,
		"gef_score_norm": 56.65137433793524,
		"gef_score_a": 25.40795480178639,
		"gef_score_b": 12.587955853093124,
		"gef_score_c": 17.399624805561036,
		"gef_score_d": 1.2558388774895706,
		"gef_score_a_norm": 63.51988700446597,
		"gef_score_b_norm": 41.959852843643745,
		"gef_score_c_norm": 86.99812402780518,
		"gef_score_d_norm": 12.558388774895707,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 0.14871,
		"trailing_return_m3": 6.20259,
		"trailing_return_m6": -1.77359,
		"trailing_return_y1": 6.75061,
		"trailing_return_y3": 4.94074,
		"trailing_return_y5": 10.94242,
		"trailing_return_y10": 4.92419,
		"trailing_return_y15": 4.73916,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-03-31T00:00:00.000Z",
		"index_name": "MSCI ACWI ex U.S.",
		"footprint": 209.78019554956103,
		"intensity": 263.09407571940983,
		"name": "ACWX - iShares MSCI ACWI ex U.S. ETF",
		"label": "ACWX - iShares MSCI ACWI ex U.S. ETF"
	},
	{
		"fund_id": "FSUSA08N99",
		"investment_vehicle_id": "FOUSA06OEZ",
		"ticker": "ACWI",
		"fund_legal_name": "iShares MSCI ACWI ETF",
		"morningstar_category_name": "Global Large-Stock Blend",
		"fund_net_assets": 18800809088,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 3,
		"c2f5coogutweight": 0.09463617362605777,
		"cl_weight": 0.19847796171543794,
		"fossil_bank_score": 19.607,
		"fossil_insure_score": 18.7475,
		"wff_mil_weight": 0.036628409057576354,
		"mmc_weight": 0.036628409057576354,
		"cm_weight": 0.015416610666536667,
		"nw_weight": 0.023278540958743328,
		"wff_civ_weight": 0.0061378592525718045,
		"gm_weight": 0.0009243282597211401,
		"gr_weight": 0.005213530992850665,
		"t_all_weight": 0.015678702660681332,
		"to_weight": 0.006867260600364399,
		"tm_weight": 0.008811442060316936,
		"po_producer_weight": 0.005224602176550944,
		"po_financier_weight": 0.037568800846521665,
		"po_consumer_weight": 0.10000642987273622,
		"pp_weight": 0.11530168343725283,
		"borders_weight": 0.1114740563943952,
		"pp_high_weight": 0.0021750719303514645,
		"borders_high_weight": 0.012932511870092233,
		"pff_all_weight": 0.14047983872948439,
		"pff_all_high_weight": 0.013130876013079575,
		"pff_all_extreme_weight": 0.00007453407412443583,
		"gef_score_norm": 55.210958323799865,
		"gef_score_a": 26.237940412934893,
		"gef_score_b": 10.077366935904216,
		"gef_score_c": 18.09378870915606,
		"gef_score_d": 0.8018622657985668,
		"gef_score_a_norm": 65.59485103233723,
		"gef_score_b_norm": 33.59122311968072,
		"gef_score_c_norm": 90.46894354578029,
		"gef_score_d_norm": 8.018622657985668,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": -3.80613,
		"trailing_return_m3": -0.99656,
		"trailing_return_m6": -1.92442,
		"trailing_return_y1": 7.42862,
		"trailing_return_y3": 7.16567,
		"trailing_return_y5": 15.26491,
		"trailing_return_y10": 8.98519,
		"trailing_return_y15": 8.99908,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-03-31T00:00:00.000Z",
		"index_name": "MSCI ACWI",
		"footprint": 132.11577835385125,
		"intensity": 218.71048453380192,
		"name": "ACWI - iShares MSCI ACWI ETF",
		"label": "ACWI - iShares MSCI ACWI ETF"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/CoreBenchmarks.json
// module id = 946
// module chunks = 0